import { Box, Button, FullScreenDialog, Grid, GridColumn, GridItemGrow, ModalDialog, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [openFH, setOpenFH] = useState(false);
	const [openFS, setOpenFS] = useState(false);
	const onClose = () => {
		setOpenFH(false);
		setOpenFS(false);
	};

	return (
		<Box>
			<CssColumnGrid columns={2}>
				<Button design="primary" onClick={() => setOpenFH(true)}>
					Full Height Dialog
				</Button>
				<Button design="primary" onClick={() => setOpenFS(true)}>
					Full Screen Dialog
				</Button>
			</CssColumnGrid>
			<ModalDialog
				fullHeight
				onClose={onClose}
				open={openFH}
				showDividers
				title="Dialog Title"
			>
				{{
					buttons: (
						<Button design="link" onClick={onClose}>Close</Button>
					),
					main: (
						<Text text="Test of full height dialog" />
					),
				}}
			</ModalDialog>
			<FullScreenDialog onClose={onClose} open={openFS}>
				<GridColumn
					fullHeight
					grow
					growChild={0}
					spacing={4}
					spacingAround={4}
				>
					<Box>
						<Text text="Test of full screen dialog; ESC will also close unless use disableEscapeKeyDown" />
					</Box>
					<Box textAlign="right">
						<Button design="secondary" onClick={onClose}>Close</Button>
					</Box>
				</GridColumn>
			</FullScreenDialog>
		</Box>
	);
};